import {useEffect} from 'react';

export const useEffectOnce = callback => useEffect(callback, []);

export const navigatorTo = (to, navigation, props={}) => {
    return () => {
        return navigation.navigate(to, props);
    };
};
